

require('xo-wallet-components');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-credit-components/src/pay-with-credit/directive');

var _pxp = require('xo-page-components/src/cart/lib/pxp');

var _checkout = require('xo-models/src/checkout');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// <pay-with-credit>
// <xo-tooltip>
(0, _angular.$registerDirective)('xo-review-paywith', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=',
            showBmlPopup: '=',
            installmentNotSelected: '=',
            payButtonText: '=',
            installment: '='
        },

        controller: function controller($scope) {

            $scope.locale = _squid.$locale;
            $scope.formatCurrency = _squid.formatCurrency;

            // check for feature enabled in config/inc/ui.json for AU country
            // this feature is there only in country AU as of June 29th, 2015
            $scope.showUachFeatureDiscalimer = false;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
                payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {

                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = _squid.$util.param('useraction');
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            }).then(function () {

                var merchant = $scope.checkoutAppData.merchant;
                $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                $scope.sacEligible = function (fsType) {
                    if (fsType !== 'BILL_ME_LATER') {
                        return false;
                    }

                    var total = $scope.checkoutCart.get('purchase.amounts.total');
                    if (total && !$scope.installment.showCYCO && parseFloat(total.amount) >= _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
                        return true;
                    }
                };

                var isBilling = $scope.checkoutCart.isBilling();
                var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
                var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                // Hide 'change' link for sticky disabled merchants
                $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);

                var checkoutPlan = $scope.checkoutSession.plan;
                $scope.canChangeFI = true;
                if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB()) {
                    $scope.canChangeFI = false;
                } else if (checkoutPlan.isBalance()) {
                    $scope.canChangeFI = $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred());
                }

                $scope.gotoWallet = function () {
                    if ($scope.canChangeFI) {
                        _uiRouter.$state.go('checkout.review.sidebar.wallet');
                    }
                };

                $scope.bmlSeeTerms = function () {
                    $scope.showBmlPopup();
                };

                var stickyEligible = isBilling && !disableStickyForMerchant;
                // save sticky decision - to be used in the app and other components
                _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;

                $scope.getPlanList = function () {
                    // with purchase - always use plan
                    var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : $scope.checkoutSession.plan.sources;

                    $scope.showUachFeatureDiscalimer = false;

                    // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
                    angular.forEach(planList, function (plan) {
                        // display uach - direct debit agreement for AU as of July 1st, 2015
                        if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
                            $scope.showUachFeatureDiscalimer = true;
                        }
                    });

                    return planList;
                };

                $scope.showBackupPlan = function () {
                    return $scope.checkoutSession.plan.backup && !(stickyEligible && isBillingNoPurchase);
                };

                if (isBilling) {
                    $scope.isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
                }

                function getBAContent() {
                    var consentCode = $scope.checkoutCart.billing.consent_code;
                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
                    var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();

                    var contentKey;
                    if (consentCode) {
                        contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
                    } else {
                        contentKey = 'billingAgreement.';
                        if (stickyEligible && stickyFI) {

                            $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING' && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en';

                            contentKey += $scope.isCIB ? 'memberAgreementCibSticky' : 'memberAgreementFiSticky' + useraction;
                        } else {
                            contentKey += 'memberAgreementNoFiSticky' + useraction;
                        }
                    }
                    return contentKey;
                }

                function getRPContent() {
                    var contentKey = 'billingAgreement.';
                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                    if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
                        contentKey += 'rpAgreementFiSticky' + useraction;
                    } else {
                        contentKey += 'rpAgreementNoFiSticky' + useraction;
                    }
                    return contentKey;
                }

                if (isBilling) {
                    $scope.baContentKey = getBAContent();
                    $scope.rpContentKey = getRPContent();
                }

                $scope.getStickyFiName = function () {
                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.name;
                };

                $scope.getStickyFiLast4 = function () {
                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
                };
            }).then(function () {
                var negBals = $scope.checkoutSession.negBals;

                // re-order multiple currencies when first balance has different currency
                if (negBals && negBals[0] !== $scope.checkoutCart.purchase.amounts.currency_code) {
                    negBals = negBals.reverse();
                }
                $scope.negBals = negBals;
            }); // end $populate chain
        } // end controller function
    };
}); // accessibility directives
// <xo-cvv>


_pxp.$pxpCartAmt;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CreditOptionsModel;

_checkout.$CheckoutPayeeModel;

_squid.formatCurrency;

_squid.$util;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$locale;

_uiRouter.$state;

_angular.$registerDirective;


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/review-paywith/directive.js
// module id = ./components/xo-member-components/src/review-paywith/directive.js
// module chunks = 1